module.exports = __webpack_public_path__ + "static/media/mmf_pausenanimation_small_003.3a11deb6.png";